<template>
    <li
    v-if="financing.length != 0"
    class="financing-box">
        <div class="title">
            <h1>融资</h1>
            <el-link
            type="primary"
            :underline="false"
            href="/Index/finance.html"
            target="_blank">
            我要融资></el-link>
        </div>
        
        <div class="con financing">
            <el-table
            :data="financing"
            stripe
            border
            style="width: 100%">
                <el-table-column
                prop="time"
                label="日期">
                </el-table-column>
                <el-table-column
                prop="rounds"
                label="轮次">
                </el-table-column>
                <el-table-column
                prop="amount"
                label="金额">
                </el-table-column>
                <el-table-column
                prop="investor"
                label="投资方">
                </el-table-column>
            </el-table>
        </div>

        <el-link
        type="primary"
        :underline="false"
        href="/Index/dsb_product.html"
        target="_blank"
        style="width: 100%; line-height: 40px;">
        更多数据></el-link>
    </li>
</template>

<script>
export default {
    name: 'financing',
    data() {
        return {
            financing: []
        }
    },
    mounted() {
        axios.get('/Index/investment_json?name=' + this.$route.query.name)
        .then((res) => {
            var arr = []
            if(res.data.list.length != 0) {
                res.data.list.forEach(item => {
                    arr.push(
                        {
                            time: item.dtime,
                            rounds: item.shares,
                            amount: item.a100,
                            investor: item.a102,
                        }
                    )
                })
            }
            this.financing = arr.sort((a, b) => (+new Date(b.time.split(/年|月|日/).join('/'))) - (+new Date(a.time.split(/年|月|日/).join('/')))).slice(0, 3)
        })
    },
}
</script>